
define('ItemsSearcher.Collection.Site'
,	[
        'ItemsSearcher.Collection'
	,	'SC.Configuration'
	,	'Item.Collection'
    ,	'Profile.Model'
    ,	'Session'

	,	'underscore'

	,	'Utils'
	,	'typeahead'
	]
,	function (
        ItemsSearcherCollection
	,	Configuration
	,	ItemCollection
    ,	ProfileModel
    ,   Session

	,	_
	)
{
	'use strict';

    _.extend(ItemsSearcherCollection.prototype, {
        url : _.wrap(ItemsSearcherCollection.prototype.url, function(fn) {
            var url = fn.apply(this, _.toArray(arguments).slice(1));

            //var tisSite = SC.ENVIRONMENT.siteSettings.displayname;
            var tisSite = SC.ENVIRONMENT.siteSettings.id;

            if (tisSite) {
                //tisSite = encodeURIComponent(tisSite.replace(/ /g, '-'));
                url = _.addParamsToUrl(url, {
                    subweb: tisSite
                })
            }
            return url;
        })
    })
});

